<template>
  <BaseCheckBox
    v-model="hasNeeds"
    name="hasSpeicialNeeds"
    form-name="dummy"
    single
    :label="label"
  />

  <BaseTextArea
    v-if="hasNeeds"
    v-model="text"
    :form-name="formName"
    :rules="rules"
    name="speicialNeeds"
    label="Please describe these needs"
  />
</template>

<script setup lang="ts">
import { ref, watchEffect } from "vue";

import BaseCheckBox from "@/shared/BaseCheckBox.vue";
import BaseTextArea from "@/shared/BaseTextArea.vue";
import { Validators } from "@/utilities/validations";

type Props = {
  label: string;
  formName: string;
  rules: Validators<string | null>;
};

defineProps<Props>();

const text = defineModel<string | null>();
const hasNeeds = ref(text.value ? true : false);

watchEffect(() => {
  if (!hasNeeds.value) {
    text.value = "";
  }
});
</script>
